var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3249 10.2373H20.6V10.2H12.5V13.8H17.5864C16.8443 15.8956 14.8503 17.4 12.5 17.4C9.51785 17.4 7.1 14.9822 7.1 12C7.1 9.01785 9.51785 6.6 12.5 6.6C13.8765 6.6 15.1289 7.1193 16.0824 7.96755L18.6281 5.4219C17.0207 3.92385 14.8706 3 12.5 3C7.52975 3 3.5 7.02975 3.5 12C3.5 16.9703 7.52975 21 12.5 21C17.4703 21 21.5 16.9703 21.5 12C21.5 11.3966 21.4379 10.8075 21.3249 10.2373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53809 7.81095L7.49504 9.9795C8.29514 7.9986 10.2328 6.6 12.5004 6.6C13.8769 6.6 15.1293 7.1193 16.0828 7.96755L18.6285 5.4219C17.0211 3.92385 14.871 3 12.5004 3C9.04349 3 6.04559 4.95165 4.53809 7.81095Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 21C14.8243 21 16.9366 20.1104 18.5336 18.6636L15.7481 16.3065C14.8445 16.991 13.7213 17.4 12.4996 17.4C10.1587 17.4 8.171 15.9074 7.4222 13.8243L4.4873 16.0856C5.9768 19.0002 9.0017 21 12.4996 21Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.325 10.2374L21.3177 10.2H20.6H12.5V13.8H17.5864C17.23 14.8067 16.5824 15.6747 15.7472 16.307C15.7476 16.3065 15.7481 16.3065 15.7485 16.3061L18.534 18.6632C18.3369 18.8423 21.5 16.5 21.5 12C21.5 11.3966 21.4379 10.8075 21.325 10.2374Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.76047c402cbf4ba14743326b0a255e84.svg";
export { ForwardRef as ReactComponent };